module.exports = __webpack_public_path__ + "static/yushLogoWhite-d1d15f1a9621abeb1028b1ce8eccd8c4.png";